// Loads the Cloudflare Turnstile script once, on demand.
//
// Deliberately not in index.html: the challenge only matters when someone
// actually clicks a booking button, and every visitor should not pay for a
// third-party script on first paint.

const SCRIPT_ID = 'cf-turnstile-script';
const SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let loader = null;

export const loadTurnstile = () => {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (loader) return loader;

  loader = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    const script = existing || document.createElement('script');

    const onLoad = () => {
      if (window.turnstile) resolve(window.turnstile);
      else reject(new Error('Turnstile loaded without exposing its API'));
    };

    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener(
      'error',
      () => {
        loader = null; // allow a retry on the next click
        reject(new Error('Failed to load the verification widget'));
      },
      { once: true }
    );

    if (!existing) {
      script.id = SCRIPT_ID;
      script.src = SRC;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });

  return loader;
};
